var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm.label
          ? _c(
              "label",
              {
                staticClass: "col-form-label",
                class: _vm.getLabelClasses(),
                attrs: { for: _vm.id },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.label) +
                    "\n                "
                ),
                _c("span", { staticClass: "req" }, [
                  _vm._v(_vm._s(_vm.getRequired())),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.vm,
              expression: "vm",
            },
          ],
          staticClass: "form-control",
          class: _vm.getInputClasses(),
          attrs: {
            type: "text",
            placeholder: _vm.label,
            id: "form-order-" + _vm.id,
            "aria-disabled": _vm.disabled,
          },
          domProps: { value: _vm.vm },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.vm = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.getError()
          ? _c("div", {
              staticClass: "invalid-feedback",
              domProps: { textContent: _vm._s(_vm.getError()) },
            })
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }